export default __webpack_public_path__ + "static/media/vanity700x459.64576d62.jpg";